import React from "react";
import { Dialog, DialogContent } from "@material-ui/core";
import styled from "styled-components/macro";

import { ReactComponent as MailArrow } from "../../../../svgs/MailArrow.svg";

const SaveButton = styled.button`
  border-radius:10px;
  background: linear-gradient(to bottom, #005AA9D9, #005AA9);
  width: 132px;
  height: 37px;
  color: #FFFFFF;
  border-bottom: 1px solid #004989;    
  border-left: none;
  border-right: none;
  border-top: none;
  cursor: pointer;
`;

const DiscardButton = styled.button`
  border-radius:10px;
  background: #F7F7F7;
  width:132px;
  height: 37px;
  border: 1px solid #E1E1E1;
  color: #005AA9;
  cursor: pointer;
  margin-left:37px;
  margin-right:20px;
  border-width: 0.5px 0.5px 1px 0.5px;
`;

const StyledDialog = styled(Dialog)`
  box-shadow: 0px 4px 8px 0px #00000040;
  border: 1px solid #DADCE0;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  z-index: 1300 !important;
  position: fixed !important;
  pointer-events: all !important;
`;

const StyledDialogContent = styled(DialogContent)`
  width: 357px;
`;

const WaitText = styled.p`
  font-family: 'Metropolis';
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 24px;
  text-align: center;
  color: rgba(16, 47, 84, 0.8);
  margin-bottom:12px;
  margin-top:20px;
`;

const DialogText = styled.p`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 130%;
  display: flex;
  align-items: center;
  text-align: center;
  color: rgba(16, 47, 84, 0.7);
`;

const StyledMailArrow = styled(MailArrow)`
  margin: 0 auto;
  color: #005AA9;
  position: relative;
`;

const IconContainer = styled.div`
  display: flex;
`;

const ButtonGroup = styled.div`
  margin-top: 39px;
`;

export const EdcConfirmationModal = ({
  show,
  onClose,
  config
}) => {
  const { title, bodyText, confirmationButtonText, cancellationButtonText, icon } = config;

  const getIcon = _icon => (<StyledMailArrow />);

  const iconElement = getIcon(icon);

  return (
    <StyledDialog
      modal
      maxWidth="md"
      open={show}
      autoDetectWindowHeight
      autoScrollBodyContent
    >
      <StyledDialogContent>
        <IconContainer>
          {iconElement}
        </IconContainer>
        <WaitText>{title}</WaitText>
        <DialogText>{bodyText}</DialogText>
        <ButtonGroup>
          <DiscardButton onClick={onClose}>{cancellationButtonText}</DiscardButton>
          <SaveButton onClick={onClose}>{confirmationButtonText}</SaveButton>
        </ButtonGroup>
      </StyledDialogContent>
    </StyledDialog>
  );
};
